import React from 'react'
import DashboardHeader from '../../components/Shop/Layout/DashboardHeader'
import DashboardSideBar from '../../components/Shop/Layout/DashboardSideBar'
import ShopManagementPageHero from '../../components/Shop/Layout/ShopManagementPageHero';
import AllPurchases from '../../components/Shop/AllPurchases';

const ShopAllPurchases = () => {
  return (
        <div className="shop-management-page">
            <DashboardHeader />
            <div className="shop-management-layout">
                <div className="shop-management-sidebar-slot">
                  <DashboardSideBar active={13} />
                </div>
                <main className="shop-management-main-panel">
                   <ShopManagementPageHero
                    eyebrow="B2B Purchasing"
                    title="All Purchases"
                    copy="Track wholesale and shop-to-shop purchases with responsive order tables."
                   />
                   <AllPurchases />
                </main>
              </div>
        </div>
  )
}

export default ShopAllPurchases